module.exports = __webpack_public_path__ + "img/2016-min.4bedd5d7.jpg";